import React from "react";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function NotFoundPage() {
  return (
    <SiteLayout>
      <section className="relative overflow-hidden">
        <div aria-hidden className="absolute inset-0 brp-hero-glow" />
        <div className="relative mx-auto w-full max-w-3xl px-5 sm:px-8 lg:px-10 py-32 sm:py-40 text-center">
          <div className="text-[11px] tracking-[0.28em] uppercase text-[hsl(var(--brp-orange))]">404</div>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl font-semibold tracking-tight">This page took a detour.</h1>
          <p className="mt-4 text-[hsl(var(--brp-ink-dim))]">The page you’re looking for isn’t here — but everything else is exactly where it should be.</p>
          <div className="mt-8 flex justify-center gap-3">
            <Link to="/"><Button className="rounded-full bg-[hsl(var(--brp-blue))] hover:bg-[#2563EB] text-white px-6">Return Home <ArrowRight className="ml-2 h-4 w-4" /></Button></Link>
            <Link to="/contact"><Button variant="outline" className="rounded-full border-border/70 px-6">Let’s Talk</Button></Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}
